/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
/* eslint-disable react/no-did-update-set-state */
/* eslint-disable no-underscore-dangle */
/* eslint-disable react/no-danger */
/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/no-unused-state */
import React, { Component } from "react";
import { createStyles, withStyles, Button } from "@material-ui/core";
import { reduxForm } from "redux-form";
import { connect } from "react-redux";
import { EditOutlined } from "@material-ui/icons";
import Sidebar from "../common/Header";
import { CustomizedTables, StyledTableCell } from "../common/Table";
import AddPopup from "../common/AddPopup";
import {
  addP1of2Action,
  getP1of2Action,
  updateP1of2Action,
  getByIdP1of2Action,
} from "../../../utils/actions/admin.p1of2.action";
import UpdatePopup from "../common/UpdatePopup";
import styles from "./Part1of2complete.styles";
class Part1of2Complete extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isAdd: false,
      isUpdate: false,
      title: "",
      id: "",
    };
  }

  componentDidMount() {
    this.props.getP1of2Action();
  }

  componentDidUpdate(preProps) {
    if (this.props.addData !== preProps.addData) {
      this.props.getP1of2Action();
    }
    if (this.props.updateData !== preProps.updateData) {
      this.props.getP1of2Action();
    }
    if (this.props.getByIdData !== preProps.getByIdData) {
      const data = this.props.getByIdData;
      this.setState({
        isUpdate: true,
        title: data.completeAssessment,
        id: data._id,
      });
    }
  }

  handleSubmit = () => {
    const { title, isAdd, isUpdate, id } = this.state;
    if (isAdd) {
      const data = {
        completeAssessment: title,
        for: "completeAssessment",
      };
      this.props.addP1of2Action(data);
      this.setState({ isAdd: false, title: "", id: "" });
    }
    if (isUpdate) {
      const data = {
        completeAssessment: title,
        for: "completeAssessment",
      };
      this.props.updateP1of2Action(id, data);
      this.setState({ isUpdate: false, title: "", id: "" });
    }
  };

  render() {
    const { classes } = this.props;
   

    const inputField = [
      { lable: "Title", value: "title", fieldType: "editor" },
    ];
    const updateInputField = [
      {
        lable: "Title",
        name: "title",
        value: this.state.title,
        fieldType: "editor",
      },
    ];
    const rows = this.props.getData.map((data, index) => {
      if (data.completeAssessment) {
        return (
          <>
            <StyledTableCell>{index + 1}</StyledTableCell>
            <StyledTableCell>
              <p
                dangerouslySetInnerHTML={{ __html: data.completeAssessment }}
              />
            </StyledTableCell>
            <StyledTableCell align="left">
              <EditOutlined
                style={{ cursor: "pointer" }}
                onClick={() => this.props.getByIdP1of2Action(data._id)}
              />
              <Button
                color={data.status === "active" ? "primary" : "secondary"}
                onClick={() =>
                  this.props.updateP1of2Action(data._id, { status: "active" })
                }
              >
                Active
              </Button>
              <Button
                color={data.status === "deactive" ? "primary" : "secondary"}
                onClick={() =>
                  this.props.updateP1of2Action(data._id, { status: "deactive" })
                }
              >
                Deactive
              </Button>
            </StyledTableCell>
          </>
        );
      }
    });
    return (
      <>
        <Sidebar />
        <div className={classes.root}>
          {this.state.isUpdate && (
            <UpdatePopup
              headerTitle="Update Part 1 of 2 Data"
              isOpen={this.state.isUpdate}
              inputField={updateInputField}
              onEditorTextChange={(data) => this.setState({ title: data })}
              onAdd={this.handleSubmit}
              onCancel={() => this.setState({ isUpdate: false })}
            />
          )}
          {this.state.isAdd ? (
            <AddPopup
              headerTitle="Add Part 1 of 2 Data"
              isOpen={this.state.isAdd}
              inputField={inputField}
              onEditorTextChange={(data) => this.setState({ title: data })}
              onAdd={this.handleSubmit}
              onCancel={() => this.setState({ isAdd: false })}
            />
          ) : (
            <Button
              className={classes.addButton}
              onClick={() => this.setState({ isAdd: true })}
            >
              Add Part 1 of 2 Data
            </Button>
          )}
          <CustomizedTables
            headers={["Sr. No.", "Title", "Action"]}
            rows={rows}
            loaded={this.props.getDataLoader}
          />
        </div>
      </>
    );
  }
}

Part1of2Complete.defaultProps = {
  getData: [],
  getDataLoader: true,
};

const connected = connect(
  (state) => ({
    addData: state.addP1of2,
    getData: state.getP1of2.getP1of2Data,
    getDataLoader: state.getP1of2.request,
    updateData: state.updateP1of2.updateP1of2Data,
    getByIdData: state.getByIdP1of2.getByIdP1of2Data,
  }),
  {
    addP1of2Action,
    getP1of2Action,
    updateP1of2Action,
    getByIdP1of2Action,
  }
)(Part1of2Complete);

const formed = reduxForm({
  form: "P1of2",
})(connected);



export default withStyles(styles)(formed);
